import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getApplyProcessFormByFormId, formFillSave } from '@/services/processApply';
import { complete } from '@/services/form';
import { getWormingScope } from '@/services/form';
import { message } from 'ant-design-vue';
import { setAuthorization, removeAuthorization } from '@/utils/request';
import { startProcess } from '@/services/myApply';
import jweixin from 'weixin-js-sdk';
export default {
  name: 'MobileApply',
  data: function data() {
    return {
      loading: false,
      submitting: false,
      formObject: {
        organPostId: [],
        summary: '',
        organId: null,
        postId: null
      },
      options: [],
      // 级联选择数据
      jsonData: {
        list: [],
        config: {}
      },
      editData: {},
      versionId: '',
      formName: '',
      formId: '',
      formVerData: {},
      isEdit: false,
      procInsId: '',
      editItemId: null,
      userId: ''
    };
  },
  mounted: function mounted() {
    // 获取 URL 参数
    var _this$$route$query = this.$route.query,
      formId = _this$$route$query.formId,
      type = _this$$route$query.type,
      processInstanceId = _this$$route$query.processInstanceId,
      id = _this$$route$query.id,
      mobileToken = _this$$route$query.mobileToken,
      mobileUserId = _this$$route$query.mobileUserId,
      formName = _this$$route$query.formName;
    this.formId = formId;
    this.formName = formName;
    this.isEdit = type == 1 || type == 4;
    this.procInsId = processInstanceId;
    this.editItemId = id;
    this.userId = mobileUserId;
    sessionStorage.removeItem('token');
    removeAuthorization('Bearer');
    sessionStorage.setItem('token', mobileToken);
    setAuthorization(mobileToken);
    if (this.isEdit && this.procInsId) {
      this.loadEditData();
    } else if (this.formId) {
      this.loadFormDesign(this.formId);
    } else {
      message.error('缺少必要参数');
      return;
    }
    this.loadOrganPostData();
  },
  methods: {
    // 获取表单设计（新增模式）
    loadFormDesign: function loadFormDesign(formId) {
      var _this = this;
      this.loading = true;
      getApplyProcessFormByFormId({
        formId: formId
      }).then(function (res) {
        if (res.data.code === 200) {
          var data = res.data.data;
          if (!data) {
            message.error('请设计表单后再发起申请');
            _this.loading = false;
            return;
          }
          _this.formVerData = data;
          _this.versionId = data.id;
          var formConfig = JSON.parse(data.formData.value);
          _this.jsonData = formConfig;
          _this.initEditData(_this.jsonData.list);
          _this.$nextTick(function () {
            if (_this.$refs.generateForm) {
              _this.$refs.generateForm.refresh();
              _this.$refs.generateForm.setData(_this.editData);
            }
          });
        } else {
          message.error(res.data.message || '加载表单失败');
        }
        _this.loading = false;
      }).catch(function (err) {
        message.error('网络异常');
        _this.loading = false;
      });
    },
    // 初始化 editData 默认值
    initEditData: function initEditData(list) {
      var _this2 = this;
      var _traverse = function traverse(fields) {
        fields.forEach(function (field) {
          if (field.type === 'grid') {
            field.columns.forEach(function (col) {
              return _traverse(col.list);
            });
          } else if (field.type === 'inline' || field.type === 'tabs') {
            _traverse(field.list || (field.tabs ? field.tabs.flatMap(function (t) {
              return t.list;
            }) : []));
          } else if (field.type === 'report') {
            var _field$rows;
            (_field$rows = field.rows) === null || _field$rows === void 0 || _field$rows.forEach(function (row) {
              return row.columns.forEach(function (col) {
                return _traverse(col.list);
              });
            });
          } else {
            if (field.model && !_this2.editData.hasOwnProperty(field.model)) {
              var _field$options$defaul, _field$options;
              var defaultValue = (_field$options$defaul = (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.defaultValue) !== null && _field$options$defaul !== void 0 ? _field$options$defaul : '';
              _this2.$set(_this2.editData, field.model, defaultValue);
            }
          }
        });
      };
      _traverse(list);
    },
    // 加载编辑数据
    loadEditData: function loadEditData() {
      var _this3 = this;
      this.loading = true;
      // 根据您的接口调整，这里假设有根据 processInstanceId 获取填写数据的接口
      import('@/services/myApply').then(function (_ref) {
        var getMyApplyDetailsById = _ref.getMyApplyDetailsById;
        getMyApplyDetailsById({
          processInstanceId: _this3.procInsId
        }).then(function (res) {
          if (res.data.code === 200) {
            var data = res.data.data;
            _this3.jsonData = JSON.parse(data.formData);
            _this3.editData = JSON.parse(data.fillData);
            _this3.formObject.summary = data.summary || '';
            _this3.formObject.organPostId = [data.organId, data.postId].filter(Boolean);
            _this3.formVerData = {
              sjybm: data.sjybm,
              sjjbm: data.sjjbm,
              fillformid: data.fillformid
            };
            _this3.versionId = data.versionId;
            _this3.formId = data.formId;
            _this3.$nextTick(function () {
              if (_this3.$refs.generateForm) {
                _this3.$refs.generateForm.refresh();
                _this3.$refs.generateForm.setData(_this3.editData);
              }
            });
          } else {
            message.error(res.data.message || '加载数据失败');
          }
          _this3.loading = false;
        }).catch(function (err) {
          message.error('网络异常');
          _this3.loading = false;
        });
      });
    },
    // 加载组织岗位数据
    loadOrganPostData: function loadOrganPostData() {
      var _this4 = this;
      getWormingScope({
        formId: this.formId,
        userId: this.userId
      }).then(function (res) {
        if (res.data.data && res.data.data.length) {
          var data = res.data.data[0];
          if (_this4.formObject.organPostId.length === 0) {
            var _data$postList;
            _this4.formObject.organPostId = [data.organId, (_data$postList = data.postList) === null || _data$postList === void 0 || (_data$postList = _data$postList[0]) === null || _data$postList === void 0 ? void 0 : _data$postList.postId].filter(Boolean);
          }
          _this4.options = res.data.data.map(function (item) {
            var _item$postList;
            return {
              label: item.organName,
              value: item.organId,
              children: ((_item$postList = item.postList) === null || _item$postList === void 0 ? void 0 : _item$postList.map(function (sub) {
                return {
                  label: sub.postName,
                  value: sub.postId
                };
              })) || []
            };
          });
        }
      }).catch(function (err) {
        return void 0;
      });
    },
    onOrganAndJob: function onOrganAndJob(value) {
      if (value && value.length >= 2) {
        this.formObject.organId = value[0];
        this.formObject.postId = value[1];
      }
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    validateBasic: function validateBasic() {
      if (!this.formObject.organPostId.length) {
        message.warning('请选择所属组织及岗位');
        return false;
      }
      if (!this.formObject.summary.trim()) {
        message.warning('请输入概述');
        return false;
      }
      return true;
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var fillData, saveRes, fillId, startRes, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (_this5.validateBasic()) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this5.submitting = true;
              _context.p = 2;
              fillData = _this5.editData;
              if (!_this5.$refs.generateForm) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return _this5.$refs.generateForm.getData();
            case 3:
              fillData = _context.v;
            case 4:
              _context.n = 5;
              return formFillSave({
                id: _this5.editItemId || undefined,
                formId: _this5.formId,
                formName: _this5.formName,
                sjybm: _this5.formVerData.sjybm,
                sjjbm: _this5.formVerData.sjjbm,
                fillformid: _this5.formVerData.fillformid,
                versionId: _this5.versionId,
                fillData: fillData,
                summary: _this5.formObject.summary,
                organId: _this5.formObject.organPostId[0],
                postId: _this5.formObject.organPostId[1]
              });
            case 5:
              saveRes = _context.v;
              if (!(saveRes.data.code !== 200)) {
                _context.n = 6;
                break;
              }
              message.error(saveRes.data.message || '保存失败');
              return _context.a(2);
            case 6:
              fillId = saveRes.data.data;
              if (!(_this5.isEdit && _this5.procInsId)) {
                _context.n = 8;
                break;
              }
              _context.n = 7;
              return _this5.completeProcess(_this5.procInsId);
            case 7:
              _context.n = 12;
              break;
            case 8:
              _context.n = 9;
              return startProcess({
                formName: _this5.formName,
                formId: _this5.formId,
                versionId: _this5.versionId,
                fillData: fillData,
                fillId: fillId
              });
            case 9:
              startRes = _context.v;
              if (!(startRes.data.code === 200)) {
                _context.n = 11;
                break;
              }
              _context.n = 10;
              return _this5.completeProcess(startRes.data.data);
            case 10:
              jweixin.miniProgram.navigateBack({
                delta: 1
              });
              _context.n = 12;
              break;
            case 11:
              message.error(startRes.data.message || '启动流程失败');
            case 12:
              _context.n = 14;
              break;
            case 13:
              _context.p = 13;
              _t = _context.v;
              message.error('提交失败');
            case 14:
              _context.p = 14;
              _this5.submitting = false;
              return _context.f(14);
            case 15:
              return _context.a(2);
          }
        }, _callee, null, [[2, 13, 14, 15]]);
      }))();
    },
    completeProcess: function completeProcess(procInsId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var completeRes, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return complete({
                procInsId: procInsId,
                comment: '发起流程申请',
                processStatus: 1
              });
            case 1:
              completeRes = _context2.v;
              if (completeRes.data.code === 200) {
                message.success('提交成功');
                // 关闭当前页面（如果是小程序环境）
                if (window.__wxjs_environment === 'miniprogram') {
                  window.wx.miniProgram.navigateBack();
                } else {
                  _this6.$router.go(-1);
                }
              } else {
                message.error(completeRes.data.message || '提交失败');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              message.error('提交失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    }
  }
};